import getStore from '../store/store';
import * as React from 'react';
import { TxpOptionState } from '../store/schema/TxpOptionState';
import getTxpSettings from 'owa-calendar-configuration/lib/utils/getTxpSettings';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { getFallbackValueIfNull } from 'owa-options-core';
import { updateTxpFlagV2 } from '../actions/txpOptionsActions';
import TxpEventsPanelV2 from './TxpEventsPanelV2';
import { observer } from 'mobx-react';

const styles = require('./TxpOptions.scss');

export interface TxpFullV2Props {
    optionStore?: TxpOptionState;
}

@observer
export default class TxpFullV2 extends React.Component<TxpFullV2Props, {}> {
    render() {
        const optionStore = getStore();

        const txpSettings = getTxpSettings();

        if (!txpSettings) {
            return null;
        }

        // Initializing all the flags for the UI
        const CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(
            optionStore.CreateEventsFromEmailAsPrivate,
            txpSettings.CreateEventsFromEmailAsPrivate
        );

        return (
            <div>
                <OptionDescription>{strings.options_txp_description}</OptionDescription>

                <div className={styles.txpPrivateOption}>
                    <OptionsCheckbox
                        label={strings.options_txp_markEventsPrivate}
                        checked={CreateEventsFromEmailAsPrivate}
                        onChange={this.updateCreateEventsFromEmailAsPrivateFlag}
                    />
                </div>

                <TxpEventsPanelV2
                    formFlags={optionStore.EntityTypeProcessorLevelSettings}
                    txpSettings={txpSettings}
                />
            </div>
        );
    }

    /**
     * The event handler behind the OptionsCheckbox for setting the CreateEventsFromEmailAsPrivate flag
     */
    private updateCreateEventsFromEmailAsPrivateFlag = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        updateTxpFlagV2('CreateEventsFromEmailAsPrivate', checked);
    };
}
